<template>
  <a-row class="content-fix" type="flex">
    <!-- {{ form.id }} -->

    <spinner v-if="loading" />
    <a-col v-show="!loading" class="height100 flex-1">
      <a-tabs
        :key="$route.fullPath"
        class="main-tabs"
        type="card"
        @change="tabPaneChangeHandler"
      >
        <a-tab-pane key="content">
          <span slot="tab"> <a-icon type="project" />Содержимое </span>
          <!-- lang tabs -->
          <a-row
            align="middle"
            class="flex-baseline"
            style="margin-bottom: 15px"
          >
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Язык:
            </a-col>
            <a-col :span="12">
              <!-- lang translit tabs -->
              <a-row align="middle" class="flex-baseline flex-wrap">
                <lang-tabs v-model="langTab" class="mb-1x" />
                <a-button
                  v-if="langTab == 'uz' || langTab == 'oz'"
                  @click.stop="translitAction"
                >
                  Перевести копию на
                  {{ langTab == "uz" ? "кирилицу" : "латиницу" }}
                </a-button>
              </a-row>
            </a-col>
          </a-row>

          <!-- title -->
          <a-row
            :class="{ 'form-group--error': emptyTitle }"
            align="middle"
            class="flex-baseline"
          >
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Заголовок:
            </a-col>
            <a-col :span="12" class="sm-mb">
              <a-input
                v-model="form.title[langTab]"
                placeholder="Введите заголовок"
                @input="
                  $__slugCompute({
                    event: $event,
                    langTab: langTab,
                    type: 'post',
                    title: form.title,
                    postType: 'alerts'
                  })
                "
              />
              <div v-if="isTitleNull" class="error-text">
                Введите заголовок на одном из языков.
              </div>
            </a-col>
          </a-row>

          <!-- slug -->
          <a-row align="middle" class="flex-baseline">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              ЧПУ:
            </a-col>
            <a-col :span="12" class="sm-mb">
              <a-row align="middle" type="flex">
                <span class="mr-1 link" @click="copySlug">
                  <a-icon :style="{ fontSize: '22px' }" type="copy" />
                </span>

                <span class="flex-1">
                  <a-input
                    id="slug-input"
                    :value="form.slug"
                    placeholder="Введите человеку понятный урл"
                    @input="onSlugChange"
                  />
                </span>
              </a-row>
              <div v-if="!form.slug" class="error-text">Введите ЧПУ.</div>
              <div v-if="errors.slug" class="z-error-text">
                Данный ЧПУ недоступен
              </div>
            </a-col>
          </a-row>

          <!-- Теги -->
          <a-row align="middle" class="flex-baseline">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Теги:
            </a-col>
            <a-col :span="12" class="sm-mb">
              <vue-tags-input
                v-model="tag"
                :add-only-from-autocomplete="true"
                :autocomplete-items="filteredItems"
                :tags="form.tags"
                class="post-chips__input"
                placeholder="Введите теги, можно указать несколько"
                @tags-changed="update"
              />
            </a-col>
          </a-row>

          <!-- position -->
          <a-row align="middle" class="flex-baseline">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Позиция:
            </a-col>
            <a-col :span="12" class="sm-mb">
              <a-input
                v-model.number="form.position"
                placeholder="Введите позицию"
              />
              <div v-if="!form.position" class="error-text">
                Введите позицию.
              </div>
            </a-col>
          </a-row>

          <!-- category list -->
          <a-row style="margin-bottom: 15px">
            <a-col
              :span="6"
              style="text-align: right; padding-right: 8px; padding-top: 6px"
            >
              Категория:
            </a-col>
            <a-col :span="12">
              <a-select
                v-model="form.category_id"
                :filter-option="filterOption"
                option-filter-prop="children"
                placeholder="Выберите категорию"
                show-search
                style="width: 100%"
              >
                <a-select-option
                  v-for="category in $store.getters['categoryAlerts/list']"
                  :key="category.id"
                  :value="category.id"
                >
                  {{ category.title }}
                </a-select-option>
              </a-select>
              <div v-if="!form.category_id" class="error-text">
                Выберите категорию.
              </div>
            </a-col>
          </a-row>

          <!-- published time -->
          <a-row>
            <a-col
              :span="6"
              style="text-align: right; padding-right: 8px; padding-top: 6px"
            >
              Дата публикации:
            </a-col>
            <a-col :span="12">
              <a-date-picker
                v-model="form.created"
                :allow-clear="false"
                :format="'DD-MMM YYYY HH:mm'"
                :show-time="{ format: 'HH:mm' }"
              />
            </a-col>
          </a-row>

          <!-- editor -->
          <a-row
            :class="{ 'form-group--error': emptyContent }"
            align="middle"
            style="margin-top: 25px"
          >
            <a-col
              style="padding-top: 4px; text-align: right; padding-right: 8px"
            >
              Контент:
            </a-col>
            <a-col>
              <editor
                :key="'tinymce_' + tabPane"
                v-model="form.content[langTab]"
                :init="{
                  height: 450,
                  plugins: [
                    'iframe advlist autolink lists link image imagetools charmap print preview',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code wordcount'
                  ],
                  fontsize_formats:
                    '8px 10px 12px 14px 16px 18px 24px 36px 40px 72px',
                  toolbar:
                    'iframe undo redo | preview fullscreen | formatselect fontsizeselect | bold italic underline forecolor | \
                  image link table insertfile code | hr alignleft aligncenter alignright alignjustify | \
                  bullist numlist outdent indent | removeformat | basicDateButton selectiveDateButton toggleDateButton splitDateButton menuDateButton',
                  language: 'ru',
                  language_url: '/js/tinymce/langs/ru.js',
                  menubar: false,
                  images_upload_url: false,
                  automatic_uploads: false,
                  relative_urls: false,
                  images_reuse_filename: true,
                  images_dataimg_filter: function (img) {
                    return img.hasAttribute('internal-blob')
                  },

                  external_plugins: {
                    myplugin:
                      '/js/tinymce/plugins/image-align/editor_plugin_img.js'
                  },

                  setup: $_editorCustomWindow,

                  image_advtab: true,
                  importcss_append: true,
                  image_caption: true,

                  image_class_list: [
                    {
                      title: 'Some class',
                      value: 'class-name',
                      active: true,
                      selected: true
                    },
                    { title: 'None', value: '' }
                  ]
                  // file_picker_callback: function(callback, value, meta) {
                  //   console.log(callback, value, meta)
                  //   // if (meta.filetype == 'image') {
                  //   //   callback('img.jpg', {alt: 'My alt text'});
                  //   // }
                  // }
                }"
                api-key="3myux81vzip0v5yxik8wex3sk4vgt37xuna840e8nzco3rs5"
              />
              <div v-if="isContentNull" class="error-text">
                Введите контент на одном из языков.
              </div>
            </a-col>
          </a-row>

          <!-- status toggle -->
          <a-row style="margin-top: 25px">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Статус:
            </a-col>
            <a-switch v-model="form.status" />
          </a-row>

          <!-- visibity on head page -->
          <a-row style="margin-top: 25px">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Поставить на главную:
            </a-col>
            <a-switch v-model="form.is_main" />
          </a-row>

          <!-- view in slider -->
          <a-row style="margin-top: 25px">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Поставить на слайдер:
            </a-col>
            <a-switch v-model="form.to_slider" />
          </a-row>

          <!-- language availability -->
          <a-row style="margin-top: 25px">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Доступность на языке {{ langTab }}
            </a-col>
            <a-switch v-model="form.language_support[langTab]" />
          </a-row>
        </a-tab-pane>

        <!-- photo tab -->
        <a-tab-pane key="photo">
          <span slot="tab"> <a-icon type="picture" />Фото </span>

          <!-- upload photo -->
          <a-row align="middle">
            <a-col
              :span="6"
              style="padding-top: 4px; text-align: right; padding-right: 8px"
            >
              Изображения
            </a-col>
            <a-col :span="12">
              <image-upload
                :list="newsPhotos"
                :selected-image="main_image"
                accept="image/jpeg, image/png"
                method-name="news"
                multiple
                @change="handleImages"
                @drag-update="updateFilesPosition"
                @set-main-image="main_image = arguments[0]"
              />
            </a-col>
          </a-row>
        </a-tab-pane>

        <!-- video tab  -->
        <a-tab-pane key="video">
          <span slot="tab">
            <a-icon type="video-camera" />Видео для слайдера
          </span>

          <a-col>
            <a-row style="margin-bottom: 15px">
              <a-col
                :span="6"
                style="text-align: right; padding-right: 8px; padding-top: 6px"
              >
                Тип загрузки:
              </a-col>
              <a-col :span="12">
                <a-select
                  v-model="video_input.file_type"
                  placeholder="Выберите тип загрузки видео"
                  show-search
                  style="width: 100%"
                >
                  <a-select-option
                    v-for="item in videoUploadTypes"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.title[$i18n.locale] }}
                  </a-select-option>
                </a-select>
              </a-col>
            </a-row>

            <a-row
              v-if="video_input.file_type != 1"
              style="margin-bottom: 15px"
            >
              <a-col
                :span="6"
                style="text-align: right; padding-right: 8px; padding-top: 6px"
              >
                Ссылка на видео:
              </a-col>
              <a-col :span="12">
                <!--                <a-col class="mb-2" v-for="(item, index) in videoUrl">-->
                <!--                  <a-input :placeholder="placeholders.video_url[$i18n.locale]" v-model="item.file"/>-->
                <!--                </a-col>-->

                <a-col class="mb-2">
                  <a-input
                    v-model="video_input.file"
                    :placeholder="placeholders.video_url[$i18n.locale]"
                  />
                </a-col>
              </a-col>
            </a-row>

            <a-row v-else style="margin-bottom: 15px">
              <a-col
                :span="6"
                style="text-align: right; padding-right: 8px; padding-top: 6px"
              >
                Файл с компьютера:
              </a-col>
              <a-col :span="12">
                <a-button @click="$refs.videoRef.click()">
                  <input
                    ref="videoRef"
                    accept="video/*"
                    hidden
                    type="file"
                    @change="handleVideoInput"
                  />
                  <a-icon type="upload" />
                  Выберите файл
                </a-button>

                <InputFileItem
                  :file="video_file"
                  class="mt-2"
                  @delete="video_file = null"
                />
              </a-col>
            </a-row>
          </a-col>
        </a-tab-pane>

        <!-- document tab  -->
        <a-tab-pane key="document">
          <span slot="tab"> <a-icon type="file" />Документы </span>

          <a-col>
            <a-row style="margin-bottom: 15px">
              <a-col
                :span="6"
                style="text-align: right; padding-right: 8px; padding-top: 6px"
              >
                Файл документа:
              </a-col>
              <a-col :span="12">
                <a-button @click="$refs.documentRef.click()">
                  <input
                    ref="documentRef"
                    accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, text/plain, application/pdf"
                    hidden
                    type="file"
                    @change="handeDocumentInput"
                  />
                  <a-icon type="upload" />
                  Выберите файл
                </a-button>

                <InputFileItem
                  :file="document_file"
                  class="mt-2"
                  @delete="$refs.documentRef.value = document_file = null"
                />
                <InputFileItem
                  v-for="(doc, index) in newsDocs"
                  :key="index"
                  :file="{ name: doc.file.split('/').pop() }"
                  class="mt-2"
                  link
                  @delete="deleteInputFile(doc)"
                />
                <!--                {{ newsDocs }}-->
              </a-col>
            </a-row>
          </a-col>
        </a-tab-pane>

        <span v-if="form.id" slot="tabBarExtraContent">
          <a-popconfirm
            placement="bottomRight"
            title="Вы действительно хотите удалить данный объявление?"
            @confirm="removeItem"
          >
            <a-button :disabled="pending" style="margin-right: 10px">
              <a-icon type="delete" />Удалить
            </a-button>
          </a-popconfirm>
        </span>
      </a-tabs>

      <a-row class="form-buttons__action" type="flex">
        <a-col :span="6" style="text-align: right; padding-right: 8px" />
        <a-col>
          <a-button :disabled="pending" @click="$router.go(-1)">
            <a-icon type="close" />
            Отмена
          </a-button>

          <a-button
            :loading="pending"
            style="margin-left: 10px"
            type="primary"
            @click="submitNews"
          >
            <a-icon type="check" />
            {{ form.id ? "Сохранить" : "Добавить" }}
          </a-button>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
import Editor from "@tinymce/tinymce-vue"
import InputFileItem from "@/components/utils/input-file-item"
import { cloneDeep } from "lodash"

import VueTagsInput from "@johmun/vue-tags-input"

const newsDefaultFields = () => ({
  title: {
    uz: "",
    oz: "",
    ru: "",
    en: "",
    tj: "",
    kz: ""
  },
  content: {
    uz: "",
    oz: "",
    ru: "",
    en: "",
    tj: "",
    kz: ""
  },
  category_id: null,
  slug: "",
  tags: [],
  position: 1,
  status: true,
  language_support: {
    uz: false,
    oz: false,
    ru: false,
    en: false,
    tj: false,
    kz: false
  },
  is_main: false,
  created: null
})

export default {
  name: "Alerts",

  components: {
    "image-upload": () => import("@/components/utils/image-upload"),
    editor: Editor,
    InputFileItem,
    VueTagsInput
  },
  data: () => ({
    langTab: $langPrefix,
    form: {},
    created: null,
    groupCategoryList: [],
    fileList: [],
    pending: false,
    loading: false,

    previewVisible: false,
    previewImage: "",

    tabPane: null,
    main_image: null,
    video_input: {
      file_type: 3,
      file: ""
    },

    video_file: null,

    newsFiles: [],
    document_file: null,
    errors: {
      slug: ""
    },
    tag: "",
    autocompleteItems: [],
    tagTimer: null,
    emptyTitle: false,
    emptyContent: false,

    current_slug: ""
  }),

  computed: {
    isTitleNull() {
      return !!(
        !this.form.title.uz &&
        !this.form.title.oz &&
        !this.form.title.ru &&
        !this.form.title.en
      )
    },
    isContentNull() {
      return !!(
        !this.form.content.uz &&
        !this.form.content.oz &&
        !this.form.content.ru &&
        !this.form.content.en
      )
    },

    newsPhotos() {
      return (
        this.newsFiles && this.newsFiles.filter((item) => item.file_type === 0)
      )
    },

    newsVideos() {
      return (
        this.newsFiles &&
        this.newsFiles.filter(
          (item) =>
            item.file_type === 1 || item.file_type === 3 || item.file_type === 4
        )
      )
    },

    videoUrl() {
      return (
        this.newsFiles &&
        this.newsFiles
          .filter((item) => item.file_type === 3 || item.file_type === 4)
          .sort((a, b) => new Date(b.updated) - new Date(a.updated))
      )
    },

    newsDocs() {
      return (
        this.newsFiles && this.newsFiles.filter((item) => item.file_type === 2)
      )
    },

    filteredItems() {
      return (
        this.autocompleteItems.filter(
          (i) =>
            i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1 || i
        ) || []
      )
    }
  },

  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    },
    tag: "initItems",
    "form.title": {
      handler(val) {
        try {
          // this.form.language_support[ ru or other lang prefix ] = true if form.title[ lang prefix ] exists or false
          this.$set(
            this.form.language_support,
            this.langTab,
            !!val[this.langTab]
          )
        } catch (error) {
          console.log(error)
        }
      },
      deep: true
    }
  },
  created() {
    this.$set(this, "form", {
      ...newsDefaultFields(),
      category_id: +this.$route.params.cat_id || null,
      created: this.moment(new Date(), "DD-MM-YYYY")
    })

    this.$store.dispatch("tags/fetch")
  },
  mounted() {
    this.$on("update:slug", this.onSlugChange)
  },
  beforeDestroy() {
    // fields empty fix
    this.$set(this, "form", { ...newsDefaultFields() })
  },

  methods: {
    async removeItem() {
      try {
        const r = await this.$store.dispatch(
          "alerts/deleteItemAction",
          this.form.id
        )
        if (r) {
          this.$message.success("объявление успешно удалена")
          this.$router.go(-1)
        }
      } catch (err) {
        console.log(err)
      }
    },
    onSlugChange(e) {
      const text = (e.target.value || "")
        .replace(/( )/gi, "-")
        .toLowerCase()
        .replace(/[^a-zA-Z0-9\\-]/gi, "")

      this.slugCheck({
        payload: { table: "post", slug: text },
        postType: "alerts"
      })

      this.form.slug = text
    },
    setSlugRes(arg) {
      this.errors.slug = arg ? "" : "Данный ЧПУ недоступен"
    },
    copySlug() {
      this.copyStringToClipboard(`/${this.$options.name}/${this.form.slug}`)
      this.$message.success("ЧПУ скопирован")
    },
    translitAction() {
      try {
        const from = this.langTab,
          to = this.langTab == "uz" ? "oz" : "uz",
          methodName = this.langTab == "uz" ? "toKirill" : "toLatin"

        if (this.form.title[from]) {
          this.form.title[to] = this[methodName](this.form.title[from])
        }

        if (this.form.content[from]) {
          this.form.content[to] = this[methodName](this.form.content[from])
        }

        // turn on translit target language_support
        this.$set(this.form.language_support, to, true)
      } catch (error) {
        console.log("translitAction error", error)
      }
    },
    update(newTags) {
      this.autocompleteItems = []
      this.form.tags = newTags
    },
    initItems() {
      // chips, tags fetcher function

      if (this.tag.length < 2) {
        return
      }

      clearTimeout(this.tagTimer)
      this.tagTimer = setTimeout(async () => {
        try {
          const data = await this.$store.dispatch("tags/fetch")

          if (data && data.length) {
            this.autocompleteItems =
              data.map((item) => ({
                ...item,
                text: item.name
              })) || []
          }
        } catch (e) {
          console.log("initItems", e)
        }
      }, 800)
    },
    handleVideoInput(e) {
      if (e.target.files && e.target.files[0]) {
        this.video_file = e.target.files[0]
      }

      this.$refs.videoRef.value = null
    },
    handeDocumentInput(e) {
      if (e.target.files && e.target.files[0]) {
        this.document_file = e.target.files[0]
      }
    },

    updateFilesPosition() {
      let promises = []
      let otherImages = new FormData()
      const mainImage = this.fileList.find(
        (item) => item.id && item.uzid === this.main_image
      )

      if (mainImage) {
        otherImages.append("is_main", true)
        otherImages.append("file_type", 0)
        otherImages.append("position", 0)
        otherImages.append("file", mainImage.file || mainImage.fileTarget)
        promises.push(
          this.$api.put("/alerts/file/update/" + mainImage.id, otherImages)
        )
      }

      // console.log(+!!mainImage);

      // debugger;

      Array.from(this.fileList)
        .filter((item) => item.id && item.uzid !== this.main_image)
        .map((item, index) => {
          otherImages = new FormData()

          otherImages.append("is_main", false)
          otherImages.append("position", index + +!!mainImage)
          otherImages.append("file_type", 0)

          promises.push(
            this.$api.put("/alerts/file/update/" + item.id, otherImages)
          )
        })

      Promise.all(promises)
        .then(
          () => {
            // console.log(res);
          },
          (err) => {
            console.log(err)
          }
        )
        .then(() => {
          // console.log(res);
          this.$message.success("Позиции успешно сохранены")
        })
    },

    check2Null(arg) {
      // console.log("check2Null", r);

      return Object.values(arg).every((item) => !item)
    },
    async submitNews() {
      if (this.check2Null(this.form.title)) {
        this.emptyTitle = true
        return
      }
      if (this.check2Null(this.form.content)) {
        this.emptyContent = true
        return
      }

      if (this.errors.slug && this.current_slug != this.form.slug) {
        this.$message.error("ЧПУ занят, введите другое")
        return
      }

      if (this.form.slug && this.form.slug.length >= 200) {
        this.$message.error(
          "Количество символов в ЧПУ превышает предел 200 символов, укоротите ЧПУ"
        )
        return
      }

      // do your submit logic here
      this.pending = true

      let newData = cloneDeep(this.form)

      newData = {
        ...newData,
        title: JSON.stringify(newData.title),
        content: JSON.stringify(newData.content),
        created: this.moment(newData.created)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
        tags:
          (newData.tags && newData.tags.map((item) => item.id).join(",")) || ""
      }

      // return

      const createOrUpdate = {
        url:
          this.form && this.form.id
            ? "/alerts/post/update/" + this.form.id
            : "/alerts/post/create",
        method: this.form && this.form.id ? "put" : "post",
        data: newData
      }

      // console.log(createOrUpdate);

      this.$api[createOrUpdate.method](
        createOrUpdate.url,
        createOrUpdate.data,
        { timeout: 0 }
      )
        .then((res) => {
          if (res && res.status >= 200 && res.data && res.data.id) {
            if (res.data.id) {
              // eslint-disable-next-line no-unused-vars
              const { created, id } = res.data

              this.$set(this, "form", { ...this.form, id })

              // upload after post done
              this.uploadPostFiles()
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.pending = false
        })
    },
    uploadPostFiles() {
      this.pending = true

      let promises = []

      // upload images
      let img = new FormData()
      Array.from(this.fileList).map((item, index) => {
        const req = {
          attr: "create",
          id: this.form.id,
          method: "post"
        }

        if (item.id) {
          req.attr = "update/" + item.id
          req.id = item.id
          req.method = "put"
          img.append("file", item.file)
        } else {
          img.append("file", item.fileTarget)
        }
        img.append("is_main", this.main_image == item.uzid)
        img.append("news_id", this.form.id)
        img.append("file_type", 0)
        img.append("status", true)
        img.append(
          "position",
          this.main_image == item.uzid ? 0 : index == 0 ? 1 : index
        )

        promises.push(this.$api[req.method](`/alerts/file/${req.attr}`, img))
      })

      //  for (var value of img.values()) {
      //         console.log(value);
      //         }

      // upload video
      if (this.video_input.file && this.form.id) {
        const f = new FormData()
        let req = {
          url: "create",
          method: "post"
        }

        f.append(
          "file",
          this.video_input.file_type == 1
            ? this.video_file
            : this.video_input.file
        )
        f.append("file_type", this.video_input.file_type)
        f.append("news_id", this.form.id)
        f.append("status", true)
        f.append("is_main", true)
        f.append("position", 1)

        if (this.video_input.id) {
          req = {
            url: "update/" + this.video_input.id,
            method: "put"
          }
        }

        promises.push(this.$api[req.method]("/alerts/file/" + req.url, f))
      }

      // upload docs
      if (this.document_file) {
        const f = new FormData()
        f.append("file", this.document_file)
        f.append("news_id", this.form.id)
        f.append("file_type", 2)
        f.append("status", true)
        f.append("is_main", true)
        f.append("position", 1)
        promises.push(this.$api.post("/alerts/file/create", f))
      }

      Promise.all(promises)
        .then(
          (res) => {
            console.log(res)
          },
          (err) => {
            console.log(err)
          }
        )
        .then(() => {
          this.pending = false
          this.$message.success("объявление успешно сохранено")
          this.$router.go(-1)
        })
        .catch(() => (this.pending = false))
    },
    async fetchData() {
      this.loading = true
      this.$store.dispatch("categoryAlerts/fetch")

      if (isNaN(this.$route.params.id)) {
        this.loading = false
        return
      }

      this.$api
        .get("/alerts/post/detail/" + this.$route.params.id)
        .then(async (res) => {
          if (res && res.data) {
            // skip non important keys
            // eslint-disable-next-line no-unused-vars
            const { category, created, updated, views, ...data } = res.data

            this.$set(this, "form", {
              ...this.form,
              ...data,
              title: JSON.parse(data.title),
              content: JSON.parse(data.content),
              created: this.moment(created),
              tags:
                (data.tag_list &&
                  data.tag_list.map(({ id, name }) => ({ id, text: name }))) ||
                [],

              language_support: data.language_support
            })

            this.$set(this, "current_slug", this.form.slug)
          }

          await this.fetchNewsFiles()
          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
        })
    },

    async fetchNewsFiles() {
      if (!this.$route.params.id) {
        console.log("No params id")
        return
      }

      return this.$api
        .get("/alerts/file/list/" + this.$route.params.id)
        .then((res) => {
          // console.log("fetchNewsFiles", res);
          this.newsFiles = res.data

          // set first element of video files as video_url
          if (
            this.videoUrl &&
            this.videoUrl.length &&
            this.videoUrl[0] &&
            this.videoUrl[0].file
          ) {
            this.video_input = this.videoUrl[0]
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
    },
    handleChange({ fileList }) {
      console.log(fileList)
      this.fileList = fileList
    },
    handleImages(arg) {
      this.fileList = arg
    },
    tabPaneChangeHandler(arg) {
      // tinymce reload fix, !!! important
      this.tabPane = arg
    },

    async deleteInputFile(arg) {
      try {
        const res = await this.$store.dispatch("file/delete", arg.id)

        if (res) {
          const f = this.newsFiles.findIndex((item) => item.id == arg.id)

          if (f != -1) {
            this.newsFiles.splice(f, 1)
          }
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>
